// Example: ipToInt("192.168.0.1"); // → 3232235521
function ipToInt(ip) {
  return ip.split(".").reduce((int, octet) => (int << 8) + parseInt(octet, 10), 0) >>> 0;
}

// Example: intToIp(3232235521); // → "192.168.0.1"
function intToIp(int) {
  return [(int >>> 24) & 255, (int >>> 16) & 255, (int >>> 8) & 255, int & 255].join(".");
}

// Example: maskToPrefix("255.255.255.0"); // → 24
function maskToPrefix(mask) {
  return (
    mask
      .split(".")
      .map((octet) => parseInt(octet, 10).toString(2))
      .join("")
      .split("1").length - 1
  );
}

// Example: prefixToMask(24); // → "255.255.255.0"
function prefixToMask(prefix) {
  return Array(4)
    .fill(0)
    .map((_, i) => {
      const bits = Math.min(8, Math.max(0, prefix - i * 8));
      return 256 - Math.pow(2, 8 - bits);
    })
    .join(".");
}

function isValidIPv4(ip) {
  const octets = ip.split(".");
  if (octets.length !== 4) return false;

  return octets.every((octet) => {
    const num = Number(octet);
    return /^\d+$/.test(octet) && num >= 0 && num <= 255;
  });
}

function isValidSubnetMask(mask) {
  const binary = mask.split(".").map((octet) => {
    const num = parseInt(octet, 10);
    if (num < 0 || num > 255) return null;
    return num.toString(2).padStart(8, "0");
  });

  if (binary.includes(null)) return false;

  const joined = binary.join("");
  return /^1*0*$/.test(joined); // must be contiguous 1s followed by 0s
}

// Example: getDefaultSubnetMask("10.0.0.1"); // → "255.0.0.0"
// Example: getDefaultSubnetMask("172.16.0.1"); // → "255.255.0.0"
// Example: getDefaultSubnetMask("192.168.1.1"); // → "255.255.255.0"
function getDefaultSubnetMask(ip) {
  if (!isValidIPv4(ip)) return null;

  const firstOctet = parseInt(ip.split(".")[0], 10);

  // Class A: 0-127 (default mask /8)
  if (firstOctet >= 0 && firstOctet <= 127) {
    return "255.0.0.0";
  }
  // Class B: 128-191 (default mask /16)
  else if (firstOctet >= 128 && firstOctet <= 191) {
    return "255.255.0.0";
  }
  // Class C: 192-223 (default mask /24)
  else if (firstOctet >= 192 && firstOctet <= 223) {
    return "255.255.255.0";
  }
  // Class D (224-239) and Class E (240-255) don't have default masks
  else {
    return null;
  }
}

export { ipToInt, intToIp, maskToPrefix, prefixToMask, isValidIPv4, isValidSubnetMask, getDefaultSubnetMask };
